export default {
    async isAvailableAsync() {
        return false;
    },
};
//# sourceMappingURL=ExponentMagnetometer.web.js.map